const FETCHING = "misc/FETCHING";
const FETCHING_ERROR = "misc/FETCHING_ERROR";
const FETCHING_SUCCESS = "misc/FETCHING_SUCCESS";

const initialState = { sets: [], tcgplayerSale: 0, themes: [], tribes: [] };

const misc = (state = initialState, action) => {
  switch (action.type) {
    case FETCHING_SUCCESS:
      return {
        ...state,
        ...action.data,
      };
    default:
      return state;
  }
};

export const fetchMisc = () => async (dispatch) => {
  dispatch({ type: FETCHING });
  const res = await fetch("https://json.edhrec.com/static/misc");
  const json = await res.json();

  // Active tcgplayer sale?
  const tcgplayerSale =
    json.tcgplayerKickback &&
    new Date() > new Date(json.tcgplayerKickback.start) &&
    new Date() < new Date(json.tcgplayerKickback.end)
      ? json.tcgplayerKickback.percent
      : 0;

  return dispatch({ data: { ...json, tcgplayerSale }, type: FETCHING_SUCCESS });
};

export default misc;
